import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { PdfPageContent } from '../PdfPageContent/PdfPageContent';
import { TextPageContent } from '../TextPageContent/TextPageContent';
import { VideoPageContent } from '../VideoPageContent/VideoPageContent';
export const CustomPageContent = (param)=>{
    let { page, contentResetKey, isReadOnly, submitAttempted, lockedExisting, getSourceId, onPageUpdate, textTestId, pdfTestId, videoTestId } = param;
    const handleTextIdChange = useCallback((newTextId)=>{
        onPageUpdate(page.id, (p)=>p.type === 'text' ? _object_spread_props(_object_spread({}, p), {
                text: _object_spread_props(_object_spread({}, p.text), {
                    textId: newTextId
                })
            }) : p);
    }, [
        onPageUpdate,
        page.id
    ]);
    const handleContentEmptyChange = useCallback((isEmpty)=>{
        onPageUpdate(page.id, (p)=>p.type === 'text' ? _object_spread_props(_object_spread({}, p), {
                text: _object_spread_props(_object_spread({}, p.text), {
                    isEmpty
                })
            }) : p);
    }, [
        onPageUpdate,
        page.id
    ]);
    const handleSaveFailedChange = useCallback((saveFailed)=>{
        onPageUpdate(page.id, (p)=>p.type === 'text' ? _object_spread_props(_object_spread({}, p), {
                text: _object_spread_props(_object_spread({}, p.text), {
                    saveFailed
                })
            }) : p);
    }, [
        onPageUpdate,
        page.id
    ]);
    const handlePdfFileChange = useCallback((file)=>{
        onPageUpdate(page.id, (p)=>p.type === 'pdf' ? _object_spread_props(_object_spread({}, p), {
                pdf: {
                    pdfName: file.pdfName,
                    pdfFileName: file.pdfFileName
                }
            }) : p);
    }, [
        onPageUpdate,
        page.id
    ]);
    const handleVideoUrlChange = useCallback((url)=>{
        onPageUpdate(page.id, (p)=>p.type === 'video' ? _object_spread_props(_object_spread({}, p), {
                video: {
                    videoUrl: url
                }
            }) : p);
    }, [
        onPageUpdate,
        page.id
    ]);
    switch(page.type){
        case 'text':
            return /*#__PURE__*/ _jsx(TextPageContent, {
                testId: textTestId,
                textId: page.text.textId,
                mintOnFirstWrite: !!lockedExisting,
                saveFailed: page.text.saveFailed,
                getSourceId: getSourceId,
                onTextIdChange: handleTextIdChange,
                onContentEmptyChange: handleContentEmptyChange,
                onSaveFailedChange: handleSaveFailedChange,
                disabled: isReadOnly,
                submitAttempted: submitAttempted
            }, contentResetKey);
        case 'pdf':
            return /*#__PURE__*/ _jsx(PdfPageContent, {
                testId: pdfTestId,
                pdfName: page.pdf.pdfName,
                pdfFileName: page.pdf.pdfFileName,
                onFileChange: handlePdfFileChange,
                disabled: isReadOnly,
                submitAttempted: submitAttempted
            }, contentResetKey);
        case 'video':
            return /*#__PURE__*/ _jsx(VideoPageContent, {
                testId: videoTestId,
                value: page.video.videoUrl,
                onChange: handleVideoUrlChange,
                disabled: isReadOnly,
                submitAttempted: submitAttempted
            }, contentResetKey);
    }
};
